import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#fffbf5]/90 backdrop-blur-md border-b border-stone-200" data-id="element-83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="flex justify-between items-center h-20" data-id="element-85">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-86">
            <img src="https://cdn.magicpatterns.com/uploads/2pSPbYAXJgMUjkWB2iejxz/bevegtoday.png" alt="BeVegToday" className="h-12 w-auto object-contain" data-id="element-87" />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-88">
            <a href="#" className="text-stone-600 hover:text-green-600 font-medium transition-colors" data-id="element-89">
              Home
            </a>
            <a href="#finder" className="text-stone-600 hover:text-green-600 font-medium transition-colors" data-id="element-90">
              Find Recipes
            </a>
            <a href="#generator" className="text-stone-600 hover:text-green-600 font-medium transition-colors" data-id="element-91">
              Generate Recipe
            </a>
            <a href="#shopping-list" className="text-stone-600 hover:text-green-600 font-medium transition-colors" data-id="element-92">
              Shopping List
            </a>
            <a href="#categories" className="text-stone-600 hover:text-green-600 font-medium transition-colors" data-id="element-93">
              Categories
            </a>
            <a href="#videos" className="text-stone-600 hover:text-green-600 font-medium transition-colors" data-id="element-94">
              Videos
            </a>
            <a href="https://www.youtube.com/c/BeVegToday" target="_blank" rel="noopener noreferrer" className="bg-orange-600 hover:bg-orange-700 text-white px-5 py-2.5 rounded-full font-semibold transition-all shadow-lg shadow-orange-600/20" data-id="element-95">
              Subscribe
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-96">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-stone-600 hover:text-green-600 p-2" data-id="element-97">
              {isMenuOpen ? <X size={24} data-id="element-98" /> : <Menu size={24} data-id="element-99" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-[#fffbf5] border-b border-stone-200 absolute w-full" data-id="element-100">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-101">
            <a href="#" className="block px-3 py-3 text-stone-600 hover:text-green-600 hover:bg-green-50 rounded-lg font-medium" data-id="element-102">
              Home
            </a>
            <a href="#finder" className="block px-3 py-3 text-stone-600 hover:text-green-600 hover:bg-green-50 rounded-lg font-medium" data-id="element-103">
              Find Recipes
            </a>
            <a href="#generator" className="block px-3 py-3 text-stone-600 hover:text-green-600 hover:bg-green-50 rounded-lg font-medium" data-id="element-104">
              Generate Recipe
            </a>
            <a href="#shopping-list" className="block px-3 py-3 text-stone-600 hover:text-green-600 hover:bg-green-50 rounded-lg font-medium" data-id="element-105">
              Shopping List
            </a>
            <a href="#categories" className="block px-3 py-3 text-stone-600 hover:text-green-600 hover:bg-green-50 rounded-lg font-medium" data-id="element-106">
              Categories
            </a>
            <a href="#videos" className="block px-3 py-3 text-stone-600 hover:text-green-600 hover:bg-green-50 rounded-lg font-medium" data-id="element-107">
              Videos
            </a>
            <a href="https://www.youtube.com/c/BeVegToday" target="_blank" rel="noopener noreferrer" className="block w-full mt-4 bg-orange-600 hover:bg-orange-700 text-white px-5 py-3 rounded-lg font-semibold text-center" data-id="element-108">
              Subscribe
            </a>
          </div>
        </div>}
    </nav>;
}